import React from "react";

import "./styles.css";

const Skeleton = (): React.JSX.Element => {
  return <span className="arrow-link">ABS</span>;
};

export default Skeleton;
